import {
  EPromoCampaignGenerationType,
  EPromoScopeType,
  EPromoValueType,
} from 'types';

export enum ETabsModal {
  GOODS = 'GOODS',
  SERVICES = 'SERVICES',
  TARIFFS = 'TARIFFS',
}

export interface IChosenClientItem {
  id: string;
  title: string;
  type: 'client' | 'group';
}

export interface IChosenPositions {
  title: string;
  id: number;
  type?: ETabsModal;
}

export interface IFormValues {
  // Общая информация
  code: string;
  title: string;
  amount: number | '';
  rewardType: EPromoValueType | null;
  rewardValue: number | '';

  // Области применения
  scopes: EPromoScopeType[];

  // Генерация
  codesCount: number | '';
  codeLength: number | null;
  prefix?: string;
  format: EPromoCampaignGenerationType | null;

  // Статусы
  active: boolean;
  is_tracked: boolean;

  // Даты
  activeFrom?: string | null;
  activeTo?: string | null;

  chosenItems?: IChosenClientItem[];
  areas?: any[];
  chosenPositions?: IChosenPositions[];
}
